<template>
  <van-form @submit="onSubmit">
    <van-field
      name="source"
      label="服务类型"
      required
      label-align="right"
      :rules="[{ required: true, message: '请选择服务类型' }]"
    >
      <template #input>
        <van-radio-group v-model="formData.source" direction="horizontal" @change="onSourceChange">
          <van-radio :name="1" icon-size="15px">线索征集</van-radio>
          <van-radio :name="2" icon-size="15px">报警求助</van-radio>
          <van-radio :name="3" icon-size="15px">投诉举报</van-radio>
        </van-radio-group>
      </template>
    </van-field>

    <van-field
      v-if="formData.source === 1"
      name="source_type"
      v-model="formData.source_type"
      label="线索类型"
      required
      label-align="right"
      :rules="[{ required: true, message: '请选择线索类型' }]"
    >
      <template #input>
        <div
          :class="[state.selectedSourceTypeText ? 'active' : null, 'form__dropdown-select']"
          @click="state.showSourceType = true"
        >
          {{ state.selectedSourceTypeText || '请选择举报类型' }}
          <van-icon name="arrow-down" style="margin-left: 5px" />
        </div>
      </template>
    </van-field>

    <!-- <van-field
      v-model="formData.report_theme"
      name="report_theme"
      required
      label="举报主题"
      label-align="right"
      placeholder="请填写举报主题"
      maxlength="100"
      :rules="[{ required: true, message: '请填写举报主题' }]"
    />
    <van-field
      v-model="formData.informer"
      required
      type="text"
      name="informer"
      label="被举报人名"
      label-align="right"
      placeholder="请填写被举报人的姓名或网络昵称"
      maxlength="20"
      :rules="[{ required: true, message: '请填写被举报人的姓名或网络昵称' }]"
    /> -->

    <!-- <van-field name="type" label="举报类型" label-align="right" required>
      <template #input>
        <van-radio-group direction="horizontal" v-model="formData.type">
          <van-radio :name="1" icon-size="15px">内容违规</van-radio>
          <van-radio :name="2" icon-size="15px">产品功能</van-radio>
        </van-radio-group>
      </template>
    </van-field> -->

    <!-- <van-field
        v-model="formData.department"
        required
        name="department"
        label="被举报站点"
        label-align="right"
        placeholder="被举报站点"
        maxlength="100"
        :rules="[
          {
            pattern: urlReg,
            required: true,
            message: '请填写被举报站点，必须为网址'
          }
        ]"
      /> -->
    <van-field
      v-model="formData.content"
      required
      type="textarea"
      name="content"
      label="事件概述"
      show-word-limit
      maxlength="2000"
      label-align="right"
      placeholder="请填写举报内容"
      :rules="[{ required: true, message: '请填写举报内容' }]"
    />
    <van-field name="file" label="图片上传" label-align="right">
      <template #input>
        <van-uploader
          name="file"
          accept="image/png,image/jpeg,image/jpg,image/gif,image/bmp,image/webp"
          v-model="formData.file"
          :after-read="clickUpload"
        />
      </template>
    </van-field>
    <!-- <van-field
        v-model="formData.area_name"
        readonly
        required
        clickable
        name="area_name"
        label="选择地区"
        label-align="right"
        right-icon="arrow"
        placeholder="请选择您的地区"
        :rules="[{ required: true, message: '请选择您的地区' }]"
        @click="state.showPicker = true"
      /> -->
    <van-field
      v-model="formData.contacts"
      required
      name="contacts"
      label="联系人"
      label-align="right"
      placeholder="请填写举报人姓名"
      maxlength="20"
      :rules="[{ required: true, message: '请填写举报人姓名' }]"
    />
    <van-field
      v-model="formData.tel"
      required
      name="tel"
      label="联系电话"
      label-align="right"
      placeholder="请填写正确的电话号码"
      :rules="[
        {
          pattern: mobileReg,
          required: true,
          message: '请填写正确的电话号码'
        }
      ]"
    >
      <template #button>
        <van-button
          size="mini"
          round
          native-type="button"
          style="width: 80px"
          @click="sendSMS"
          :disabled="state.complainSMS.disabled"
          :type="state.complainSMS.primary"
          >{{ state.complainSMS.text }}</van-button
        >
      </template>
    </van-field>
    <van-field
      v-model="formData.code"
      name="code"
      required
      label="验证码"
      label-align="right"
      placeholder="请填写正确的验证码"
      type="number"
      maxlength="6"
      @update:model-value="verifyUpdate"
      :rules="[
        {
          pattern: /\d{6}/,
          required: true,
          message: '请填写正确的验证码'
        }
      ]"
    />
    <van-field
      v-model="formData.email"
      required
      name="email"
      label="联系邮箱"
      label-align="right"
      placeholder="请填写正确的联系邮箱"
      :rules="[
        {
          pattern: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/,
          required: true,
          message: '请填写正确的联系邮箱'
        }
      ]"
    />
    <van-field
      v-model="formData.uid"
      name="uid"
      label="用户UID"
      label-align="right"
      type="number"
      placeholder="用户在投诉平台的ID"
      :rules="[
        {
          validator(rule, value, callback, source, options) {
            if (/\d+/.test(rule) || rule === '') {
              return true;
            }
            return false;
          },
          message: '用户在投诉平台的ID'
        }
      ]"
    />
    <van-field
      v-model="formData.uname"
      name="uname"
      label="用户昵称"
      label-align="right"
      maxlength="20"
      placeholder="请填写用户在投诉平台上的昵称"
    />
    <van-field
      v-model="formData.source_url"
      name="source_url"
      label="投诉地址"
      label-align="right"
      placeholder="请输入正确的网址"
      :rules="[
        {
          validator(rule, value, callback, source, options) {
            if (
              /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([:?#=/\w.-]*)*\/?$/.test(rule) ||
              rule === ''
            ) {
              return true;
            }
            return false;
          },
          message: '请输入正确的网址'
        }
      ]"
    />
    <van-field
      v-model="formData.product_name"
      name="product_name"
      label="产品名称"
      label-align="right"
      placeholder="请填写投诉平台上的产品名称"
    />
    <van-row justify="center" class="van-container-top">
      <div class="form__agree" @click="onAgree">
        <van-checkbox
          class="form__agree-checkbox"
          v-model="state.isAgree"
          shape="square"
          :icon-size="15"
          @click="onAgree"
        />
        <div class="form__agree-text">
          本人声明：本人提交的上述举报内容全部真实，并愿对此承担相应的法律责任。
        </div>
      </div>
    </van-row>

    <van-row justify="center" class="van-container-top">
      <van-col span="10">
        <van-button
          block
          round
          :disabled="state.disabledSubmit"
          type="primary"
          native-type="submit"
        >
          提交
        </van-button>
      </van-col>
      <van-col span="10" offset="1">
        <van-button block round native-type="reset" @click="cancelSubmit">取消</van-button>
      </van-col>
    </van-row>
  </van-form>
  <!-- 线索类型 -->
  <van-popup v-model:show="state.showSourceType" round position="bottom">
    <van-picker
      :columns="state.sourceType"
      @cancel="state.showSourceType = false"
      @confirm="onSourceTypeConfirm"
    />
  </van-popup>
  <!-- <van-popup v-model:show="state.showPicker" position="bottom">
    <van-area
      title="标题"
      :value="formData.area_code"
      :area-list="areaList"
      @cancel="state.showPicker = false"
      @confirm="onChangeArea"
      :columns-placeholder="['请选择', '请选择', '请选择']"
    />
  </van-popup> -->
  <!-- <sms-code v-model:visible="state.visible" :imageData="state.imageData" @smsEvent="smsEvent" /> -->
</template>

<script>
import {
  Row,
  Col,
  Button,
  Field,
  Form,
  Uploader,
  Popup,
  RadioGroup,
  Radio,
  Picker,
  Checkbox,
  Icon
} from 'vant';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { areaList } from '@vant/area-data';
import { clientUtil } from '@/utils';
import { state, formData, urlReg, mobileReg } from '../helper/data';
import helper from '../helper';
import Scheme from '@acgn/flyer/src/scheme/index';

const schemeUtil = new Scheme({ modules: { clientUtil } });
const clientInfo = clientUtil.getClientInfo();

export default {
  name: 'Add',
  components: {
    'van-button': Button,
    'van-field': Field,
    'van-form': Form,
    'van-row': Row,
    'van-col': Col,
    'van-uploader': Uploader,
    'van-popup': Popup,
    // 'van-area': Area,
    'van-radio-group': RadioGroup,
    'van-radio': Radio,
    'van-picker': Picker,
    'van-checkbox': Checkbox,
    'van-icon': Icon
    // 'sms-code': SmsCode
  },
  setup() {
    const route = useRoute();
    const { formType } = route.query;
    if (formType) {
      formData.source = Number(formType);
    }

    // const list = helper.getArea(areaList, formData.area_code).map(item => item.name);
    // formData.area_name = list.join(' / ');

    // 若果在APP内执行如下操作
    if (clientInfo.isApp) {
      const platformInfo = clientUtil.getPlatformConfig();
      const scheme_Adr = platformInfo.scheme_Adr;
      schemeUtil.getUserInfoByApp(scheme_Adr);
      const setUserInfo = data => {
        Object.assign(formData, {
          uid: data.uid || data.Uid,
          uname: data.name || data.uname || data.Uname,
          source_url: data.source_url,
          product_name: clientInfo.pName + '_' + clientInfo.os
        });
      };
      onMounted(() => {
        // 用来接收app的用户信息回调
        window.setUserInfo = setUserInfo;
      });
    }

    return {
      state,
      areaList,
      formData,
      urlReg,
      mobileReg,
      ...helper
    };
  }
};
</script>

<style lang="scss">
@import '../style/config';

.form__dropdown-select {
  border: 1px solid #c8c8c8;
  padding: 5px 30px;
  color: #c8c8c8;
  font-size: 26px;
  text-align: center;
  min-width: 300px;
  cursor: pointer;
  &.active {
    color: var(--van-radio-label-color);
  }
}

.form__agree {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 0 40px;
  margin: 0 40px;
  &-checkbox {
    margin-right: 15px;
  }
  &-text {
    font-size: 22px;
    line-height: 1.5;
    flex: 1;
  }
}
</style>
